import type { FaireProductEntity } from "../../entity_types/product";

export const p_uvh67nvdzd: FaireProductEntity = {
  token: "p_uvh67nvdzd",
  type: "product",
  name: "Teddy Pouch–Mom Stuff",
  brandToken: "b_9e5lkbzo3q",
  brandName: "The Darling Effect",
  imageUrl:
    "https://cdn.faire.com/fastly/43dd67c35d3ef08472c8c122ed82c1458589ea5f9b493f4bf3b896d4e522aa15.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/6298377fe7074be999a1848e98292b555a7994c70a169cff588697ff8c34f438.jpeg",
  ],
  priceDollars: 20.55,
  description:
    "Thoughtfully created to merchandise beautifully with our Made for Mama: Mother’s Day Collection\n\nBring a cozy, stylish touch to your everyday essentials with our teddy pouches. Made from soft sherpa fabric and finished with a wipeable interior lining, they blend charm with practicality for on-the-go organization. The polished gold zipper and printed inner fabric make the pouch just as delightful on the inside as it is on the outside. Mix and match with coordinating sizes for a darling, cohesive accessory set that works beautifully year-round.\n\nCozy sherpa fabric with wipeable interior lining for easy cleaning\nGold zipper and hardware\nInterior printed lining adds a special touch\nRectangle Teddy measures 10” x 3.5” x 6”\nSquare Teddy measures 6.5” x 2.5” x 6.5”\nCircle Teddy measures 4.5” diameter x 2”\n\n\n\nWARNING: Cancer and Reproductive Harm - www.P65Warnings.ca.gov",
  tags: [],
  msrpDollars: 41.09,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-04-19T21:22:51.719Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
